// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OcKe","input":"styles_input__2PARB"};